import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { ACCEPT_DATE_FORMAT, INPUT_MASK_DATE_FORMAT, ISODATE_FORMAT } from './date-format';
import { StringUtils } from './utils/string-utils';

/**
 * Adapts between a Buddhist-era `dd/mm/yyyy` (or ISO `yyyy-mm-dd`) string model
 * and ng-bootstrap's `NgbDateStruct` (which works in the common era).
 */
@Injectable()
export class CustomNgbDateNativeAdapterToString extends NgbDateAdapter<string> {
  fromModel(date: string | null): NgbDateStruct | null {
    if (date) {
      if (INPUT_MASK_DATE_FORMAT.test(date)) {
        if (ACCEPT_DATE_FORMAT.test(date)) {
          const value = date.split('/');
          const isoDate = `${Number(value[2]) - 543}-${value[1]}-${value[0]}`;
          return this.fromModel(isoDate);
        }
      } else if (ISODATE_FORMAT.test(date)) {
        const str = date.split('-');
        return { year: Number(str[0]), month: Number(str[1]), day: Number(str[2].split('T')[0]) };
      }
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    if (!date) {
      return null;
    }
    const day = StringUtils.paddingZeroLeft(date.day, 2);
    const month = StringUtils.paddingZeroLeft(date.month, 2);
    const year = StringUtils.paddingZeroLeft(date.year, 4);
    return `${year}-${month}-${day}`;
  }
}
